import axios from 'axios';

const HttpAction = axios.create({
    baseURL: process.env.REACT_APP_API_URL, 
    timeout: 300000 
});

const ErrorHandler = (e) => {
    let error = e;
    if (e === undefined) {
        error = {
            data: 400,
            message: 'timeout error',
            path: '/'
        }
    }
    const response = {
        code: error.data.state,
        message: error.data.error,
        path: error.data.path
    }
    return response;
}

const loadingState = (state) => {
    const active = state === true ? "block" : "none";
    document.querySelector('#loadingstate').style.display = active;
}

HttpAction.interceptors.request.use(function (config) {
    loadingState(true);

    const token = localStorage.getItem('jwt') === null ? "" : localStorage.getItem('jwt');
    config.headers["Authorization"] = `Bearer ${token}`;
    config.headers["Language"] = process.env.REACT_APP_LANGUAGE

    const fileused = config.fileused === undefined ? false : true;
    if (fileused) {
        config.headers["Content-Type"] = "multipart/form-data";
    }else{
        config.headers["Content-Type"] = "application/json; charset=utf-8";
    }
    return config;
}, function (e) {

    loadingState(false); 
    return ErrorHandler(e.response);
});

HttpAction.interceptors.response.use(function (response) {
    loadingState(false); 
    return response.data;
}, function (e) {
    loadingState(false); 
    return ErrorHandler(e.response);
});

export default HttpAction;